<div class="password-reset-container-outer">
    <div class="password-reset-container-inner">
        <ng-container *ngIf="!state.loading; else stateLoading">
            <ng-container *ngIf="!state.error; else stateError">
                <div class="card">
                    <div class="p-10" [ngSwitch]="isNewUser">
                        <h1 class="standard-heading" translate>{{eAuthMessages.FORGOT_PASSWORD}}</h1>
                        <div class="standard-description" translate>{{eAuthMessages.FORGOT_PASSWORD_DESCRIPTION}}</div>
                    </div>

                    <div class="p-10">
                        <div class="frankli-form-group frankli-form-group-filled frankli-form-group-placeholder-shown"
                             [class.frankli-form-group-invalid]="controlEmail.invalid && state.submitted">
                            <label for="email" translate>{{eAuthMessages.EMAIL_ADDRESS}}</label>
                            <input type="email" id="email" name="email" class="form-control"
                                   placeholder="johnsmith@frankli.io" autocomplete="email" [formControl]="controlEmail"
                                   (keydown.enter)="formSubmit()">
                            <div class="frankli-form-group-alert">
                                <ng-container *ngIf="state.submitted">
                                    <div *ngIf="controlEmail.hasError('required')"
                                         translate>{{eCommonMessages.FORM_REQUIRED}}</div>
                                    <div *ngIf="controlEmail.hasError('pattern')"
                                         translate>{{eCommonMessages.MUST_BE_VALID_EMAIL}}</div>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <div class="p-10 text-center">
                        <app-button (onClick)="backToLogin()" [type]="eButtonType.GRAY_INVERTED">
                            <span translate>{{eCommonMessages.CANCEL}}</span>
                        </app-button>
                        <span class="m-right-5"></span>
                        <app-button [loading]="state.submitting" (onClick)="formSubmit()">
                            <span translate>{{eCommonMessages.SUBMIT}}</span>
                        </app-button>
                    </div>
                </div>
            </ng-container>
        </ng-container>

        <ng-template #stateError>
            <div class="card">
                <app-state-error [height]="'300px'" [message]="state.errorMessage"></app-state-error>
            </div>
        </ng-template>

        <ng-template #stateLoading>
            <div class="card">
                <app-state-loading [height]="'300px'"></app-state-loading>
            </div>
        </ng-template>
    </div>
</div>